





















































































import { Vue, Component, Prop, Ref, Watch } from "vue-property-decorator";
import { COLORS, COLOR_WHEEL_URL, RED_BAR_URL } from "@/constants";
export type FeatureType = "alignment" | "font" | "color";
import { customizationStore,onboardingStore } from "@/store/typed";
import VIcon from "@/components/Common/VIcon.vue";
import { Chrome } from "vue-color";
import { isMobile } from "@/helpers/mediaQueryHelper";

const PICKER_HEIGHT = 270;

@Component({ components: { Chrome, VIcon } })
export default class BackgroundOverlay extends Vue {
  private color: string | null = null;
  private oldColor: string | null = null;
  private visible = false;
  private canvasPickerMode: any = false;
  private pickedColorConfig = {
    color: null,
    position: { x: 0, y: 0 },
    chosenColor: null,
  };
  private openColorSelector = false;
  private pickerStyle: any = { left: 0, top: 0 };
  @Prop({ required: true }) canvas: HTMLCanvasElement;

  @Ref() readonly colorPicker!: any;
  @Ref() readonly overlay!: any;

  onColorsClicked() {
    onboardingStore.setBackgroundOnboarding(false);
  }

  get rgbColorProfile() {
    const printAreaCustomization =
      customizationStore.currentPrintAreaCustomization;
    return printAreaCustomization.colorProfile != "greyscale";
  }

  get colors() {
    const printAreaCustomization =
      customizationStore.currentPrintAreaCustomization;
    if (this.rgbColorProfile) {
      return COLORS;
    } else {
      return ["#FFFFFF", "#000000"];
    }
  }

  get redBarUrl() {
    return RED_BAR_URL;
  }

  get isMobile() {
    return isMobile((this as any).$mq);
  }

  get colorWheelUrl() {
    return COLOR_WHEEL_URL;
  }

  get showBackgroundOnboarding() {
    return onboardingStore.backgroundOnboarding;
  }

  colorPreviewStyle(color: string) {
    return { background: color };
  }

  show(currentColor: string) {
    this.visible = true;
    this.oldColor = currentColor;
    this.color = currentColor;
  }

  get isVisible() {
    return this.visible;
  }

  openColorPicker(event: any) {
    (this.$refs.colorPicker as any).toggleColorBlockOverlay(event);
  }

  onColorPicked(color: string, staticColor = true) {
    if (staticColor) {
      this.canvasPickerMode = false;
      this.pickedColorConfig.color = null;
      this.pickedColorConfig.chosenColor = null;
    }
    this.color = color;
    this.$emit("changed", { color: this.color });
  }

  onColorChanged(color: string, staticColor = true) {
    this.openColorSelector = false;
    if (staticColor) {
      this.canvasPickerMode = false;
      this.pickedColorConfig.color = null;
      this.pickedColorConfig.chosenColor = null;
    }
    this.color = color;
    this.$emit("changed", { color: this.color });
  }

  get clipArea() {
    return this.printArea?.clipArea;
  }

  get pickedColor() {
    return this.pickedColorConfig.color;
  }

  get pickedAndSelectedColor() {
    return this.pickedColorConfig.chosenColor;
  }

  get printArea() {
    return customizationStore?.printArea;
  }

  get printAreaWidth() {
    return this.clipArea?.width;
  }

  eventOutsideCanvas(event) {
    const rect = this.canvas.getBoundingClientRect();
    return (
      event.clientY < rect.y ||
      event.clientY > rect.y + rect.height ||
      event.clientX < rect.x ||
      event.clientX > rect.x + rect.width
    );
  }

  rgbToHex(r: number, g: number, b: number) {
    return this.valueToHex(r) + this.valueToHex(g) + this.valueToHex(b);
  }

  valueToHex(color: number) {
    var hexadecimal = color.toString(16);
    return hexadecimal.length == 1 ? "0" + hexadecimal : hexadecimal;
  }
  onMouseMove(event) {
    if (!this.canvasPickerMode) {
      return;
    }
    const context = this.canvas.getContext("2d");
    const rect = this.canvas.getBoundingClientRect();
    if (this.eventOutsideCanvas(event)) {
      return;
    }
    const positionX = event.clientX - rect.x;
    const positionY = event.clientY - rect.y;
    const multiplier = window.devicePixelRatio;
    const rawColor = context.getImageData(
      positionX * multiplier,
      positionY * multiplier,
      1,
      1
    ).data;
    this.pickedColorConfig.color = `#${this.rgbToHex(
      rawColor[0],
      rawColor[1],
      rawColor[2]
    )}`;
  }

  toggleCanvasPickerMode() {
    this.canvasPickerMode = !this.canvasPickerMode;
    if (this.canvasPickerMode) {
      this.overlay.addEventListener("mousemove", this.onMouseMove);
    } else {
      this.overlay.removeEventListener("mousemove", this.onMouseMove);
    }
  }

  getDocumentOffsetPosition(el: any) {
    let top = 0,
      left = 0;
    while (el !== null) {
      top += el?.offsetTop || 0;
      left += el?.offsetLeft || 0;
      el = el?.offsetParent || null;
    }
    return { top, left };
  }

  onColorSelected(event: any) {
    const offset = this.getDocumentOffsetPosition(this.overlay);

    if (
      this.canvasPickerMode &&
      this.pickedColorConfig.color &&
      !this.eventOutsideCanvas(event)
    ) {
      this.pickedColorConfig.chosenColor = this.pickedColorConfig.color;
      this.onColorChanged(this.pickedColorConfig.color, false);
      this.pickedColorConfig.position = {
        x: event.clientX,
        y: event.clientY - offset.top,
      };
    }
  }

  destroy() {
    this.overlay.removeEventListener("mousemove", this.onMouseMove);
  }

  close() {
    this.visible = false;
    this.reset();
    this.$emit("done", {
      color: this.oldColor,
    });
    this.$emit("close");
  }

  get canvasPickerIndicatorStyle() {
    return {
      background: this.pickedAndSelectedColor,
      top: `${this.pickedColorConfig?.position?.y || 0}px`,
      left: `${this.pickedColorConfig?.position?.x || 0}px`,
    };
  }

  done() {
    this.visible = false;
    this.$emit("done", {
      color: this.color,
    });
    this.reset();
  }

  reset() {
    this.color = null;
    this.canvasPickerMode = false;
  }

  @Watch("visible")
  onVisibileChanged(value: any) {
    if (value) {
      this.$nextTick(() => {
        const { top, left } = this.getDocumentOffsetPosition(
          this.$refs.colorSelectorTrigger
        );
        this.pickerStyle = {
          top: `${top - PICKER_HEIGHT}px`,
          left: `${left}px`,
        };
      });
    }
  }
}
